import styled, {css} from 'styled-components';

export const Overlay = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 10;
    display: flex;
    justify-content: center;
`

export const Modal = styled.div`
    left: 50vw;
    top: 50vh;
    border-radius: 10px;
    width: fit-content !important;
    width: 100%;
    padding: 10px 20px;
    /* transform: translate(-50%); */
`

export const Button = styled.button`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    flex: 0 0 auto;
    padding: 10px 20px;
    font-size: 0.8em;
    font-weight: bold;
`